/**
 * Boutons "Enregistrer"/"Annuler" affichés pendant l'édition interactive de la vue par défaut de la
 * carte (voir `MapLibreAdapter.startEditingMapView`) — un seul widget pour les deux, contrairement
 * au tutoriel/bouton Annuler du dessin (`DrawTutorial`/`CancelDrawingButton`, indépendants l'un de
 * l'autre) : ici les deux boutons apparaissent et disparaissent toujours ensemble (sauf `onCancel`
 * omis, voir plus bas — `allowCancel: false`, voir `StartEditingMapViewOptions`).
 */
export class MapViewEditControls {
  private element: HTMLDivElement | null = null;

  constructor(private container: HTMLElement) {}

  /** `onCancel` à `null` (voir `StartEditingMapViewOptions.allowCancel`) : le bouton Annuler n'est
   * même pas créé, pas seulement désactivé/masqué en CSS — seul "Enregistrer" reste alors présent. */
  show(onSave: () => void, onCancel: (() => void) | null): void {
    if (this.element) return;

    this.element = document.createElement("div");
    this.element.className = "toka-map-view-edit-controls";

    const saveButton = document.createElement("button");
    saveButton.type = "button";
    saveButton.className = "toka-map-view-save-button";
    saveButton.textContent = "✓ Enregistrer";
    saveButton.addEventListener("click", onSave);
    this.element.appendChild(saveButton);

    if (onCancel) {
      const cancelButton = document.createElement("button");
      cancelButton.type = "button";
      cancelButton.className = "toka-map-view-cancel-button";
      cancelButton.textContent = "✕ Annuler";
      cancelButton.addEventListener("click", onCancel);
      this.element.appendChild(cancelButton);
    }

    this.container.appendChild(this.element);
  }

  hide(): void {
    this.element?.remove();
    this.element = null;
  }
}
